export const HIME_CONTACT_LINE_SIMPLE = 0;
export const HIME_CONTACT_LINE = 1;
export const HIME_CONTACT_MAIL = 2;

export const HIME_CONTACT_NAME_MAP = {
  [HIME_CONTACT_LINE_SIMPLE]: '簡単LINE',
  [HIME_CONTACT_LINE]: '有料LINE',
  [HIME_CONTACT_MAIL]: 'メール',
};